module.exports = __webpack_public_path__ + "img/title6.bf2cb52d.png";